import CryptoJS from 'crypto-js';

export function decryptResponse(encryptedResponse) {
    const encryptionKey = CryptoJS.enc.Utf8.parse(atob(process.env.VUE_APP_SECRET_KEY));

    const ciphertext = CryptoJS.enc.Base64.parse(encryptedResponse);
    const iv = CryptoJS.lib.WordArray.create(ciphertext.words.slice(0, 4));
    const encryptedData = CryptoJS.lib.WordArray.create(ciphertext.words.slice(4));

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedData },
        encryptionKey,
        { iv: iv, mode: CryptoJS.mode.CFB, padding: CryptoJS.pad.Pkcs7 }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}